export const headers = {
    headers: { 'Authorization': `Bearer ${localStorage.getItem("tokenRestaurant")}` }
};